import React from 'react';
import './BimService.css';

const BimService = () => {
  const services = [
    {
      id: 1,
      title: "BIM Modeling Services",
      items: [
        { title: "3D BIM Modeling", description: "Creation of detailed 3D models including architectural, structural, and MEP components." },
        { title: "4D BIM (Scheduling)", description: "Integration of time-related information for construction timeline management." },
        { title: "5D BIM (Cost Estimation)", description: "Adding cost information for real-time project budgeting." },
        { title: "6D BIM (Sustainability)", description: "Incorporating energy efficiency and sustainability analysis." },
        { title: "7D BIM (Facilities)", description: "Providing data for ongoing facility management." }
      ]
    },
    {
      id: 2,
      title: "BIM Coordination and Clash Detection",
      items: [
        { title: "Interdisciplinary Coordination", description: "Ensuring seamless integration of architectural, structural, and MEP models." },
        { title: "Clash Detection and Resolution", description: "Early identification and resolution of design conflicts." }
      ]
    },
    {
      id: 3,
      title: "BIM Consulting Services",
      items: [
        { title: "BIM Strategy and Implementation", description: "Helping companies develop a BIM strategy, including software selection and workflows." },
        { title: "BIM Standards and Documentation", description: "Establishing BIM standards, best practices, and documentation guidelines for consistency." }
      ]
    },
    {
      id: 4,
      title: "Scan to BIM (Point Cloud to BIM)",
      items: [
        { title: "3D Laser Scanning and Modeling", description: "Using laser scanning to capture precise data on existing conditions and converting this data to BIM models." },
        { title: "As-Built Modeling", description: "Creating accurate as-built models based on point cloud data for renovations or retrofits." }
      ]
    },
    {
      id: 5,
      title: "BIM for Prefabrication",
      items: [
        { title: "Prefabrication Modeling", description: "Creating detailed models for prefabricated components and assemblies." },
        { title: "Shop Drawing Generation", description: "Producing accurate shop drawings from BIM models for fabrication." }
      ]
    },
    {
      id: 6,
      title: "BIM Training and Support",
      items: [
        { title: "BIM Software Training", description: "Providing comprehensive training on various BIM software platforms." },
        { title: "Technical Support", description: "Ongoing support for BIM implementation and troubleshooting." }
      ]
    },
    {
      id: 7,
      title: "BIM Documentation and Deliverables",
      items: [
        { title: "Construction Documentation", description: "Creating accurate, detailed documentation for construction based on BIM models." },
        { title: "Digital Project Handover", description: "Providing digital handover documentation for project completion, such as maintenance manuals and as-built models." }
      ]
    },
    {
      id: 8,
      title: "BIM for Sustainable Design and Analysis",
      items: [
        { title: "Energy and Environmental Analysis", description: "Conducting energy analysis, solar studies, and environmental impact assessments within the BIM model." },
        { title: "LEED and Green Building Certification", description: "Supporting LEED and other green certification processes with BIM data." }
      ]
    }
  ];

  return (
    <>
      {/* Page Header */}
      <div className="page-header">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2>BIM Services</h2>
            </div>
          </div>
        </div>
      </div>

      {/* BIM Services Section */}
      <div className="bim-services">
        <div className="container">
          <div className="row">
            {services.map((service) => (
              <div key={service.id} className="col-lg-6 col-md-12">
                <div className="service-item">
                  <div className="service-header">
                    <div className="service-number">{String(service.id).padStart(2, '0')}</div>
                    <h3>{service.title}</h3>
                  </div>
                  <div className="service-content">
                    <ul>
                      {service.items.map((item, index) => (
                        <li key={index}>
                          <strong>{item.title}:</strong> {item.description}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default BimService;